module.exports = __webpack_public_path__ + "static/img/paper1.1894c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/paper1.png
// module id = TJke
// module chunks = 1